import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ServicePage({
  title,
  tagline,
  ctaText,
  ctaLink,
  htmlContent,
  imageSrc,
  imageAlt,
}) {
  return (
    <>
      <Box
        sx={{
          position: 'relative',
          backgroundColor: 'primary.dark',
          color: 'common.white',
          py: { xs: 8, md: 12 },
          textAlign: 'center',
        }}
      >
        <Container>
          <Typography variant="h3" component="h1" gutterBottom>
            {title}
          </Typography>
          {tagline && (
            <Typography
              variant="h6"
              component="p"
              gutterBottom
              sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}
            >
              {tagline}
            </Typography>
          )}
          {ctaText && ctaLink && (
            <Button
              variant="contained"
              color="secondary"
              component={Link}
              to={ctaLink}
              size="large"
            >
              {ctaText}
            </Button>
          )}
        </Container>
      </Box>

      <Container sx={{ py: 4, color: 'common.white' }}>
        {imageSrc && (
          <Box
            component="img"
            src={imageSrc}
            alt={imageAlt}
            sx={{ width: '100%', maxHeight: 300, objectFit: 'cover', mb: 2 }}
          />
        )}
        <Box
          sx={{
            '& table': { width: '100%', borderCollapse: 'collapse' },
            '& th, & td': { border: '1px solid', p: 1 },
          }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </Container>
    </>
  );
}
